import { render, screen } from '@testing-library/react'
import RedPage from './RedPage'

describe('RedPage', () => {
  test('renders the main red statement directly under the page title', () => {
    render(<RedPage />)

    expect(screen.getByRole('heading', { name: 'Red', level: 1 })).toBeTruthy()
    expect(screen.getByText(/como el micelio que hace crecer bajo tierra/i)).toBeTruthy()
    expect(screen.getByRole('heading', { name: /cómo trabajamos en red/i, level: 2 })).toBeTruthy()
    expect(screen.getByRole('heading', { name: /mapeo: red de educadoras menstruales península ibérica e islas/i, level: 2 })).toBeTruthy()
  })
})
